import React, { useEffect, useState } from 'react'

import DataTable from '../../../../../ui/DataTable/DataTable'
import ModulePanel from '../../../../../ui/ModulePanel/ModulePanel'
import { withRouter } from 'react-router-dom'
import { db } from '../../../../../config/firebase'
import { orderBy, sumBy } from 'lodash'
import { formatDateAsDayMontYearHHMM } from '../../../../../utils/date/dateFormat'
import InfoLine from '../../../../../ui/InfoLine/InfoLine'
import Price from '../../../../Products/components/ProductsList/Price'
import OrderStatus from '../../OrderStatus/OrderStatus'
import OrderDeliveryInfo from '../../OrderDeliveryInfo/OrderDeliveryInfo'
import OrderPaymentInfo from '../../OrderPaymentInfo/OrderPaymentInfo'
import { OrderCatalogBadges } from '../../OrderCatalogBadges/OrderCatalogBadges'
import getOrderPaidProducts from '../../../utils/getOrderPaidProducts'

function OrdersTable({ ...router }) {
  const [orders, setOrders] = useState([])

  useEffect(() => {
    const unsubscribe = db.collection('orders').onSnapshot((snap) => {
      const data = []
      snap.forEach((doc) => {
        const orderData = doc.data()
        data.push({
          id: doc.id,
          ...orderData,
          createdSort: orderData.created?.seconds ?? 0,
        })
      })

      setOrders(orderBy(data, ['createdSort'], ['desc']))
    })

    return () => unsubscribe()
  }, [])

  const columns = [
    {
      field: 'id',
      headerClassName: 'TableHeadCol',
      headerName: 'Номер замовлення',
      renderCell: (params) => (
        <div>
          <InfoLine title="Номер" content={params.row.orderNum} />
          <InfoLine title="id" content={params.row.id} />
        </div>
      ),

      width: 250,
    },
    {
      field: 'createdSort',
      headerName: 'Дата',
      type: 'number',
    },
    {
      field: 'created',
      headerClassName: 'TableHeadCol',
      headerName: 'Дата',
      width: 200,
      renderCell: (params) => formatDateAsDayMontYearHHMM(params.row.created),
    },
    {
      field: 'status',
      headerClassName: 'TableHeadCol',
      headerName: 'Статус',
      width: 150,
      renderCell: (params) => <OrderStatus status={params.row.status} />,
    },
    {
      field: 'guest',
      headerClassName: 'TableHeadCol',
      headerName: 'Клієнт',
      minWidth: 300,
      flex: 1,
      renderCell: (params) => `${params.row.guest.name} ${params.row.guest.lastName}`,
    },
    {
      field: 'phone',
      headerClassName: 'TableHeadCol',
      headerName: 'Телефон',
      width: 150,
      renderCell: (params) => params.row.guest.phone,
    },
    {
      field: 'email',
      headerClassName: 'TableHeadCol',
      headerName: 'E-mail',
      width: 250,
      renderCell: (params) => params.row.guest.email,
    },
    {
      field: 'deliveryInfo',
      headerClassName: 'TableHeadCol',
      headerName: 'Доставка',
      width: 300,
      renderCell: (params) => <OrderDeliveryInfo {...params.row.delivery} />,
    },
    {
      field: 'paymentInfo',
      headerClassName: 'TableHeadCol',
      headerName: 'Оплата',
      width: 300,
      renderCell: (params) => <OrderPaymentInfo {...params.row.payment} />,
    },
    {
      field: 'products',
      headerClassName: 'TableHeadCol',
      headerName: 'Каталог',
      width: 180,
      renderCell: (params) => <OrderCatalogBadges products={params.row.products} />,
    },
    {
      field: 'productsLength',
      headerClassName: 'TableHeadCol',
      headerName: 'Позицій',
      width: 100,
      renderCell: (params) => getOrderPaidProducts(params.row.products).length,
    },
    {
      field: 'productsQuantity',
      headerClassName: 'TableHeadCol',
      headerName: 'Одиниць',
      width: 100,
      renderCell: (params) => {
        const paidProducts = getOrderPaidProducts(params.row.products)
        const positionsCount = paidProducts.length
        const unitsCount = sumBy(paidProducts, (p) => p.quantity)

        return unitsCount > positionsCount ? <span style={{ color: 'red' }}>{unitsCount}</span> : unitsCount
      },
    },
    {
      field: 'orderTotals',
      headerClassName: 'TableHeadCol',
      headerName: 'Сума',
      width: 100,
      renderCell: (params) => (
        <Price num={sumBy(getOrderPaidProducts(params.row.products), (p) => p.quantity * p.price)} />
      ),
    },
    // {
    //   field: 'category',
    //   headerClassName: 'TableHeadCol',
    //   headerName: 'Категорія',
    //   width: 150,
    //   // cellClassName: 'TableTextRight',
    // },
    // {
    //   field: 'subcategory',
    //   headerClassName: 'TableHeadCol',
    //   headerName: 'Підкатегорія',
    //   renderCell: (params) => (params.row.subcategory ? params.row.subcategory.title : '-'),
    //   width: 150,
    //   // cellClassName: 'TableTextRight',
    // },
    // {
    //   field: 'product',
    //   headerName: 'Товар',
    //   headerClassName: 'TableHeadCol',
    //   minWidth: 300,
    //   flex: 1,
    //   renderCell: (params) => (
    //     <ProductWithAvatar
    //       id={params.row.id}
    //       avatar={params.row.avatar}
    //       name={params.row.name}
    //       description={params.row.descriptionShort}
    //     />
    //   ),
    // },

    // {
    //   field: 'price',
    //   headerClassName: 'TableHeadCol',
    //   headerName: 'Ціна',
    //   renderCell: (params) => <Price num={params.row.price} stroked={params.row.specPrice && true} />,
    //   width: 100,
    //   // cellClassName: 'TableTextRight',
    // },
    // {
    //   field: 'specPrice',
    //   headerClassName: 'TableHeadCol',
    //   headerName: 'Акційна ціна',
    //   renderCell: (params) => (params.row.specPrice ? <Price num={params.row.specPrice} highlighted /> : '-'),
    //   width: 100,
    //   // cellClassName: 'TableTextRight',
    // },
    // {
    //   field: 'specPriceDate',
    //   headerClassName: 'TableHeadCol',
    //   headerName: 'Термін дії акції',
    //   renderCell: (params) => (params.row.specPriceDate ? params.row.specPriceDate : '-'),
    //   width: 120,
    //   // cellClassName: 'TableTextRight',
    // },
    // {
    //   field: 'amount',
    //   headerClassName: 'TableHeadCol',
    //   headerName: 'Од. виміру',
    //   width: 100,
    //   // cellClassName: 'TableTextRight',
    // },
    // {
    //   field: 'quantity',
    //   headerClassName: 'TableHeadCol',
    //   headerName: 'Залишки',
    //   width: 150,
    //   renderCell: (params) => (
    //     <div>
    //       {params.row.remains.map((s) => (
    //         <InfoLine
    //           title={s.name}
    //           content={s.quantity <= 0 ? <span style={{ color: 'red' }}>{s.quantity}</span> : s.quantity}
    //         />
    //       ))}
    //     </div>
    //   ),
    // },
    // {
    //   field: 'updated',
    //   headerClassName: 'TableHeadCol',
    //   headerName: 'Ост. оновленння',
    //   renderCell: (params) => formatDateAsDayMontYearHHMM(params.row.updated),
    //   width: 200,
    //   // cellClassName: 'TableTextRight',
    // },

    // {
    //   field: 'categoryList',
    //   headerClassName: 'TableHeadCol',
    //   headerName: 'Ціна',
    //   width: 130,
    //   type: 'singleSelect',
    //   editable: true,
    //   valueOptions: ['I', 'II', 'III'],
    // },
    // {
    //   field: 'minstep',
    //   headerClassName: 'TableHeadCol',
    //   headerName: 'Акційна ціна',
    //   width: 130,
    // },
    // {
    //   field: 'stepPrice',
    //   headerClassName: 'TableHeadCol',
    //   headerName: 'Бренд',
    //   width: 130,
    // },
    // {
    //   field: 'stepPrice',
    //   headerClassName: 'TableHeadCol',
    //   headerName: 'Категорія',
    //   width: 130,
    // },
    // {
    //   field: 'stepPrice',
    //   headerClassName: 'TableHeadCol',
    //   headerName: 'Підкатегорія',
    //   width: 130,
    // },
    // {
    //   field: 'stepPrice',
    //   headerClassName: 'TableHeadCol',
    //   headerName: 'Остання синхронізація',
    //   width: 130,
    // },
    // {
    //   field: 'stepPrice',
    //   headerClassName: 'TableHeadCol',
    //   headerName: 'Оновлено',
    //   width: 130,
    // },
    // {
    //   field: 'stockUpdate',
    //   headerClassName: 'TableHeadCol',
    //   headerName: 'Обн. из биржи',
    //   cellClassName: 'VolumeTable-LastUpdateCell Caption-Regular',
    //   width: 200,
    //   renderCell: (params) =>
    //     formatDateAsDayMontYearHHMM(params.row.stockUpdate.seconds * 1000),
    // },

    // {
    //   field: 'actions',
    //   headerClassName: 'TableHeadCol',
    //   headerName: 'Действия',
    //   width: 100,
    //   renderCell: (params) => (
    //     <TableActions
    //       {...{
    //         params,
    //         rowOnSave,
    //         rowModesModel,
    //         setRowModesModel,
    //       }}
    //     />
    //   ),
    // },
  ]

  return (
    <ModulePanel title="Cписок замовлень">
      <DataTable
        initialState={{
          sorting: {
            sortModel: [{ field: 'createdSort', sort: 'desc' }],
          },
          columns: {
            columnVisibilityModel: {
              createdSort: false,
            },
          },
        }}
        table={{
          // editMode: 'row',
          // rowModesModel,
          // onRowModesModelChange: (model) => setRowModesModel(model),
          // rows: !isEmpty(symbols) ? symbols : [],
          rows: orders,
          columns: columns,
          // processRowUpdate: onRowUpdateSubmit,
          onRowDoubleClick: (params) => router.history.push(`/orders/list/${params.row.id}`),
          // rowsPerPageOptions={[25, 50, 100]}
          // pageSize={pageSize}
          // processRowUpdate={onRowUpdateSubmit}
          // onProcessRowUpdateError={(e) => {
          //   console.log('🚀 ~ file: ToolsTable.jsx:172 ~ ToolsTable ~ e:', e)
          // }}
          // slotProps={{
          //   toolbar: { setTickers, setRowModesModel },
          // }}
          autoHeight: true,
        }}
      />
    </ModulePanel>
  )
}

export default withRouter(OrdersTable)
